import React from 'react';
import PropTypes from 'prop-types';

/**
 * MediaLeft - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer MediaLeft for easy migration
 */
const MediaLeft = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['media-left'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      {children}
    </div>
  );
};

MediaLeft.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

MediaLeft.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default MediaLeft;
